import { render, staticRenderFns } from "./PrototypePage.vue?vue&type=template&id=17b4f648&scoped=true&"
import script from "./PrototypePage.vue?vue&type=script&lang=ts&"
export * from "./PrototypePage.vue?vue&type=script&lang=ts&"
import style0 from "./PrototypePage.vue?vue&type=style&index=0&id=17b4f648&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b4f648",
  null
  
)

export default component.exports